"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Checkbox_component_exports = {};
__export(Checkbox_component_exports, {
  Checkbox: () => Checkbox
});
module.exports = __toCommonJS(Checkbox_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"));
var import_react_stately = require("react-stately");
var import_react_aria = require("react-aria");
const Checkbox = (_a) => {
  var _b = _a, {
    name,
    id,
    label,
    ariaLabel,
    ariaLabelledBy,
    externallyManaged = false
  } = _b, props = __objRest(_b, [
    "name",
    "id",
    "label",
    "ariaLabel",
    "ariaLabelledBy",
    "externallyManaged"
  ]);
  let state = (0, import_react_stately.useToggleState)(props);
  let ref = import_react.default.useRef(null);
  let { inputProps } = (0, import_react_aria.useCheckbox)(props, state, ref);
  let { isFocusVisible, focusProps } = (0, import_react_aria.useFocusRing)();
  let isSelected = state.isSelected && !props.isIndeterminate;
  let checkboxSelectedClass = state.isSelected ? "gmui-checkbox-is-selected" : "";
  let checkboxIndeterminateClass = props.isIndeterminate ? "gmui-checkbox-is-indeterminate" : "";
  let checkboxDisabledClass = props.isDisabled ? "gmui-checkbox-is-disabled" : "";
  let checkboxInvalidClass = props.isInvalid ? "gmui-checkbox-is-invalid" : "";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    "label",
    {
      style: {
        display: "flex",
        opacity: props.isDisabled ? 0.7 : 1
      },
      className: "align-top",
      children: [
        !externallyManaged && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_aria.VisuallyHidden, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "input",
          __spreadProps(__spreadValues({}, (0, import_react_aria.mergeProps)(inputProps, focusProps)), {
            ref,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
          })
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
          "svg",
          {
            width: 32,
            height: 32,
            "aria-hidden": "true",
            style: {
              width: "35px"
            },
            "data-testid": "gmui-checkbox-wrapper",
            className: `gmui-checkbox-wrapper mb-2 ${checkboxSelectedClass} ${checkboxIndeterminateClass}`,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                "rect",
                {
                  x: 4,
                  y: 4,
                  width: 22,
                  height: 22,
                  strokeWidth: 1,
                  rx: "3",
                  "data-testid": "gmui-checkbox-rect",
                  className: `gmui-checkbox-rect ${checkboxDisabledClass} ${checkboxInvalidClass} ${checkboxIndeterminateClass}`
                }
              ),
              isSelected && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                "svg",
                {
                  x: "4",
                  y: "4",
                  width: "26",
                  height: "26",
                  viewBox: "0 0 30 30",
                  "data-testid": "gmui-checkbox-checkmark",
                  className: `gmui-checkbox-checkmark ${checkboxDisabledClass}`,
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M21 6.285l-11.16 12.733-6.84-6.018 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.285z" })
                }
              ),
              !isSelected && props.isDisabled && !props.isIndeterminate && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                "svg",
                {
                  x: "1",
                  y: "1",
                  width: "28",
                  height: "28",
                  viewBox: "0 0 32 32",
                  "data-testid": "gmui-checkbox-slash",
                  className: "gmui-checkbox-slash",
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M 26.28125 4.28125 L 4.28125 26.28125 L 5.71875 27.71875 L 27.71875 5.71875 Z" })
                }
              ),
              props.isIndeterminate && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                "rect",
                {
                  x: 7,
                  y: 14,
                  width: 16,
                  height: 1,
                  "data-testid": "gmui-checkbox-line",
                  className: `gmui-checkbox-line ${checkboxDisabledClass}`
                }
              ),
              isFocusVisible && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                "rect",
                {
                  x: 1,
                  y: 1,
                  width: 28,
                  height: 28,
                  strokeWidth: 1,
                  rx: "3",
                  "data-testid": "gmui-checkbox-focus",
                  className: "gmui-checkbox-focus"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "gmui-font-style-body-compact gmui-color-content-hierarchy-prim mt-1.5 w-fit", children: label })
      ]
    }
  );
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Checkbox
});
//# sourceMappingURL=Checkbox.component.js.map